// extracted by mini-css-extract-plugin
export default {"tAc":"Terms&Condition_tAc__fWmtX","tAc__content":"Terms&Condition_tAc__content__z6bTc"};